import type { IQrCodeLink } from '../../../../../../shared/types';
import type { DataAction } from '../../../types/dataAction.type';
import { type EditQrCodeLinkPayload, QrCodeLinkAdapterService } from '../services/QrCodeLinkAdapterService';

type Payload = { qrCodeLinkToEdit: EditQrCodeLinkPayload };

export const EDIT_QR_CODE_LINK = 'EDIT_QR_CODE_LINK' as const;

export const editQrCodeLink = (qrCodeLink: IQrCodeLink) => {
  const qrCodeLinkAdapter = new QrCodeLinkAdapterService();
  return {
    type: EDIT_QR_CODE_LINK,
    data: { qrCodeLinkToEdit: qrCodeLinkAdapter.toEditPayload(qrCodeLink) },
  };
};

export type EditQrCodeLinkResponseAction = DataAction<typeof EDIT_QR_CODE_LINK, Payload>;
